import SHAREBOX_I32_BREAKDWON_STEPS from './i32';

const SHAREBOX_M28_BREAKDOWN_STEPS = SHAREBOX_I32_BREAKDWON_STEPS;

export default SHAREBOX_M28_BREAKDOWN_STEPS;
